<ng-container [ngSwitch]="type">
	<ng-container *ngSwitchCase="'playlist'">
			<div class="overall-block playlist fx-column fx-start-stretch">
			<div class="playlist-block fx-row fx-start-stretch fx-no-grow fx-shrink">
				<ng-container *ngIf="data?.thumbnail">
					<div class="thumbnail-block fx-no-grow fx-no-shrink">
						<div class="thumbnail">
							<img [src]="data?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')"
								(click)="info(data)" class="cursor-pointer">
						</div>
					</div>
				</ng-container>
				<div class="fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="data.resourceType">
						<div class="patch fx-row fx-start-start">
							<div class="sub-txt-patch">{{data.resourceType}}</div>
						</div>
					</ng-container>
					<div class=" fx-grow fx-shrink"
						[ngClass]="{ 'fx-center-center': [null, undefined, ''].includes(data?.thumbnail), 'fx-start-center': ![null, undefined, ''].includes(data?.thumbnail) }">
						<p (click)="info(data)" class="entity-title linkable">
							{{data?.title}}
						</p>
					</div>
				</div>
				</div>
				<ng-container *ngIf="![null, undefined].includes(data?.progress)">
					<mat-progress-bar [value]="data?.progress">
					</mat-progress-bar>
				</ng-container>
			</div>
	</ng-container>

	<ng-container *ngSwitchCase="'course'">
		<div class="overall-block course fx-column fx-start-stretch">
			<div class="course-block fx-row fx-start-start">
				<ng-container *ngIf="data?.thumbnail">
					<div class="thumbnail-block fx-no-grow fx-no-shrink">
						<div class="thumbnail">
							<img [src]="data?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')"
								(click)="info(data)" class="cursor-pointer">
						</div>
					</div>
				</ng-container>
				<div class="fx-column fx-start-stretch fx-grow fx-shrink">
					<ng-container *ngIf="data.resourceType">
						<div class="patch fx-row fx-start-start">
							<div class="sub-txt-patch">{{data.resourceType}}</div>
						</div>
					</ng-container>
					<div class="fx-grow fx-shrink fx-start-center"
						[ngClass]="{ 'fx-center-center': [null, undefined, ''].includes(data?.thumbnail), 'fx-start-center': ![null, undefined, ''].includes(data?.thumbnail) }">
						<p (click)="info(data)" class="entity-title linkable">
							{{data?.title}}
						</p>
					</div>

					<!-- <ng-container *ngIf="![null, undefined].includes(data?.progress)">
					<mat-progress-bar [value]="data?.progress">
					</mat-progress-bar>
				</ng-container> -->
				</div>
			</div>
			<ng-container *ngIf="![null, undefined].includes(data?.progress)">
				<mat-progress-bar [value]="data?.progress">
				</mat-progress-bar>
			</ng-container>
		</div>
	</ng-container>

	<ng-container *ngSwitchCase="'common'">
		<div class="overall-block common fx-column fx-start-stretch">
			<div class="common-block fx-row fx-start-start">
			<ng-container *ngIf="data?.thumbnail">
				<div class="thumbnail-block fx-no-grow fx-no-shrink">
					<div class="thumbnail">
						<img [src]="data?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" (click)="info(data)"
							class="cursor-pointer">
					</div>
				</div>
			</ng-container>
			<div class="fx-column fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="data.resourceType">
					<div class="patch fx-row fx-start-start">
						<div class="sub-txt-patch">{{data.resourceType}}</div>
					</div>
				</ng-container>
				<div class="fx-grow fx-shrink fx-start-center"
					[ngClass]="{'title-no-progress':[null, undefined].includes(data?.progress)}">
					<p (click)="info(data)" class="entity-title linkable">
						{{data?.title}}
					</p>
				</div>
			</div>
			</div>
			<ng-container *ngIf="![null, undefined].includes(data?.progress)">
				<mat-progress-bar [value]="data?.progress">
				</mat-progress-bar>
			</ng-container>
		</div>
	</ng-container>

	<ng-container *ngSwitchCase="'workgroup'">
		<div class="overall-block workgroup  fx-column fx-start-stretch">
			<div class="workgroup-block fx-row fx-start-start">
			<ng-container *ngIf="data?.thumbnail">
				<div class="thumbnail-block fx-no-grow fx-no-shrink">
					<div class="thumbnail">
						<img [src]="data?.thumbnail" (error)="gfService.setErrorImage($event, 'broken_image')" (click)="info(data)"
							class="cursor-pointer">
					</div>
				</div>
			</ng-container>
					<div class="fx-column fx-start-stretch fx-grow fx-shrink">
						<ng-container *ngIf="data.resourceType">
							<div class="patch fx-row fx-start-start">
								<div class="sub-txt-patch">{{data.resourceType}}</div>
							</div>
						</ng-container>
						<div class="fx-row fx-grow fx-shrink fx-start-center">
							<p (click)="info(data)" class="entity-title linkable">
								{{data?.title}}
							</p>
						</div>

					</div>
			</div>
			<ng-container *ngIf="![null, undefined].includes(data?.progress)">
				<mat-progress-bar [value]="data?.progress">
				</mat-progress-bar>
			</ng-container>
			<ng-container *ngIf="data?.stats?.length">
				<div class="fx-row-wrap fx-center-center submition-dtl">
					<ng-container *ngFor="let stats of data?.stats">
						<div class="submission-item fx-row fx-start-center">
							<span class="prime-txt">{{stats?.caption}}</span>
							<span class="chip-patch fx-center-center">
								{{stats?.value}}
							</span>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</div>
	</ng-container>
</ng-container>
